import { render, staticRenderFns } from "./PromoEmailForm.vue?vue&type=template&id=cd90ecde&"
import script from "./PromoEmailForm.vue?vue&type=script&lang=ts&"
export * from "./PromoEmailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports